import { render, staticRenderFns } from "./PrintReport.vue?vue&type=template&id=90ee1266&scoped=true&"
import script from "./PrintReport.vue?vue&type=script&lang=js&"
export * from "./PrintReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ee1266",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('90ee1266')) {
      api.createRecord('90ee1266', component.options)
    } else {
      api.reload('90ee1266', component.options)
    }
    module.hot.accept("./PrintReport.vue?vue&type=template&id=90ee1266&scoped=true&", function () {
      api.rerender('90ee1266', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/PrintReport.vue"
export default component.exports